<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{'frontUser.book_event' | translate}}</span>
      <button mat-button class="mat-icon-button"
              (click)="dialogRef.close()"
              aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content>
<div class="book-event">
  @if (usersStr) {
    <div>
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'book_user_msg' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="users-list">{{usersStr}}</div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  }
  <mat-form-field>
    <mat-select placeholder="{{'main.events' | translate}}" [(ngModel)]="selectedEvent"
                (selectionChange)="chooseEvent()">
      @for (event of events; track $index) {
        <mat-option [value]="event" [style.color]="event?.color?.primary">
          @if (event?.title?.length > 60 || event?.dates?.length > 30) {
            <span
              matTooltip = "{{event?.title}} {{event?.startTime}} - {{event?.dates}}">
              {{event?.title}} @if (event?.startTime) {
              <span>({{event?.startTime}})</span>
              } - {{event?.dates}}
            </span>
          }
          @if (event?.title?.length <= 60 && event?.dates?.length <= 30) {
            <span>
              {{event?.title}} @if (event?.startTime) {
              <span>({{event?.startTime}})</span>
              } - {{event?.dates}}
            </span>
          }
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (selectedEventData && selectedEventData.allDates) {
    <div>
      <mat-checkbox [(ngModel)]="checkAllDates">{{'book_all_dates' | translate}}</mat-checkbox>
      <div style="margin: 5px 0">({{selectedEventData.allDates}})</div>
    </div>
  }
  @if (selectedEvent?.datesType === 'oneDay' && selectedEvent?.eventDates?.length > 1) {
    <mat-form-field>
      <mat-select placeholder="{{'event.dates' | translate}}" [(ngModel)]="selectedDate">
        @for (date of selectedEvent?.eventDates; track $index) {
          <mat-option [value]="date.date">
            {{date.date | date: 'dd.MM.yyyy'}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <div class="show-all-events">
    <mat-checkbox [(ngModel)]="showAllEvents" (change)="changeShowAll()">{{'show_all_events' | translate}}</mat-checkbox>
  </div>
  <div style="text-align: center">
    <button mat-raised-button (click)="startBooking()" [disabled]="!selectedEvent || selectedEventValidDate"
      class="add-product-button mat-white-bg my-12 mt-sm-0">
      <span>{{'frontUser.book_event' | translate}}</span>
    </button>
  </div>
  @if (result.length) {
    <div class="results">
      @for (res of result; track res; let i = $index) {
        <div class="result">
          <div class="name">{{i+1}}. {{res.user}}</div>
          <div class="msg">{{res.msg | translate}}</div>
          @if (res.type === 'ok') {
            <div class="icon"><mat-icon style="color: green; font-weight: bold">check_circle_outline</mat-icon></div>
          }
          @if (res.type === 'error') {
            <div class="icon"><mat-icon style="color: red; font-weight: bold">highlight_off</mat-icon></div>
          }
          @if (res.type === 'warning') {
            <div class="icon"><mat-icon style="color: orange; font-weight: bold">add_circle_outline</mat-icon></div>
          }
        </div>
      }
    </div>
  }
</div>
  </div>
</div>
